import styled from '@emotion/styled';
import { tokens, Stack } from '@hotjar/hotsauce';
import { ScreenshotDate } from './components/ScreenshotDate';
import { RetakeDropdown } from './components/RetakeDropdown';

const Container = styled(Stack)`
  display: inline-flex;
  height: ${tokens.spacer.x5};
  align-items: center;
  padding: ${tokens.spacer.x0} 0;
`;

export interface StatusBarCoreProps {
  screenshotDate: number;
  onRetake: () => void;
  onTakeNew: () => void;
}

export const StatusBarCore = ({
  screenshotDate,
  onRetake,
  onTakeNew,
}: StatusBarCoreProps): JSX.Element => {
  return (
    <Container spacing="x1">
      <ScreenshotDate timestamp={screenshotDate} />
      <RetakeDropdown onRetake={onRetake} onTakeNew={onTakeNew} />
    </Container>
  );
};
